import React from "react";
import * as Sentry from "@sentry/browser";

import UnexpectedErrorScene from "~/scenes/system/UnexpectedErrorScene";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: null, errorInfo: null, eventId: null,};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({error, errorInfo});

    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({eventId});
    });
  }

  render() {
    if (this.state.error) {
      return (
        <UnexpectedErrorScene
          error={this.state.error}
          errorInfo={this.state.errorInfo}
          eventId={this.state.eventId}
        />
      );
    }

    return this.props.children;
  }
}
